import React from "react";

const FormSubmit = ({ handleSubmit }) => {

  return (<>
    <div className="mb-5">
      <input type="hidden" name="_template" value="table"></input>
      <input type="hidden" name="_replyto"></input>
      <input type="hidden" name="_autoresponse" value="Thank you for contacting us. If you have any questions, we can be reached at (212) 388-1001. - Advanced Copy Center, Inc."></input>
      {/* <input type="hidden" name="_cc" value="another@email.com,yetanother@email.com"></input> */}
      <input type="hidden" name="_next" value="https://advancedcopycenter.web.app/submission"></input>
      <button 
        className="btn btn-primary" 
        type="submit" 
        name="send"
        // disabled="disabled"
        onClick={(input) => handleSubmit(input)}
      >
        Submit this Form to Get Quoted
      </button><br />
      <small>Once received your submitted form, our team will contact you shortly.</small>
    </div>
      <hr className="my-4" /></>
  );
}

export default FormSubmit;